import React, { useContext, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { TextField, Autocomplete } from "@mui/material";
import { ActionContext } from "../../data/action/ActionContext";
import { SubActionContext } from "../../data/action/SubActionContext";
import { useValidations } from "../../data/ValidationContext"; 

function ActionUpdateModal({ show, handleClose, action }) {
 
  // Context
  const { updateAction } = useContext(ActionContext);
  const { subActions } = useContext(SubActionContext);
  const { vs_action } = useValidations(); 

  // State
  
  const [name, setName] = useState(action?.name || "");
  const [selectedSubActions, setSelectedSubActions] = useState([]);


  useEffect(() => {
    if (action) {
      setName(action.name || "");
      setSelectedSubActions(
        subActions.filter((s) => action.subActions.includes(s.id))
      );
    }
  }, [action, subActions]);

  // -----------------------------
  // Initial Formik Values
  // -----------------------------
  const initialValues = {
    name: name || "",
    selectedSubActions: selectedSubActions || [],
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={vs_action} 
        onSubmit={(values) => {
          updateAction(
            action.id,
            values.name,
            values.selectedSubActions.map((s) => s.id)
          );
          handleClose();
        }}
      >
        {({ values, setFieldValue, touched, errors }) => (
          <Form>
            {/* Modal Header */}
            <Modal.Header closeButton>
              <Modal.Title>Aksiyon Güncelle</Modal.Title>
            </Modal.Header>

            {/* Modal Body */}
            <Modal.Body>
              {/* Ana aksiyon adı */}
              <Field
                as={TextField}
                name="name"
                label="Aksiyon Adı"
                variant="outlined"
                size="small"
                fullWidth
                value={values.name}
                onChange={(e) => setFieldValue("name", e.target.value)}
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                className="my-2"
              />

              {/* Alt aksiyonlar */}
              <h6>Alt Aksiyonlar</h6>
              <Autocomplete
                multiple
                options={subActions}
                getOptionLabel={(option) => option.name}
                value={values.selectedSubActions}
                onChange={(e, newValue) =>
                  setFieldValue("selectedSubActions", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Alt Aksiyon Seç"
                    size="small"
                    error={
                      touched.selectedSubActions &&
                      !!errors.selectedSubActions
                    }
                    helperText={
                      touched.selectedSubActions &&
                      errors.selectedSubActions
                    }
                  />
                )}
                className="my-2"
              />
            </Modal.Body>

            {/* Modal Footer */}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default ActionUpdateModal;
